import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { DatePicker, Form, Input, Tooltip, Upload, Icon, Alert } from 'antd'
import moment from 'moment'
import {
    infoRequired,
    validateName,
    validateCpf,
    validateTelefone,
    validateEmail,
} from '../../utils/validators'
import {
    maskCpfOnChange as maskCpf,
    maskTelefoneOnChange as maskTelefone,
    maskNomeOnChange,
    alphaOnlyOnChange,
} from '../../utils/masks'
import 'moment/locale/pt-br'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { PureComponent } from 'react'
import { ReactComponent as UploadIcon } from '../../images/document-upload.svg'

const { Dragger } = Upload

const NomeCelular = () => (
    <>Celular<Tooltip className="ml-2" title="Certifique-se de que o número de celular está correto. Poderemos solicitar verificação via SMS em alguns de nossos serviços."><FontAwesomeIcon icon={faInfoCircle} /></Tooltip></>
)

const FormDados = Form.create({ name: 'form-dados' })(
    ({ form, beforeUpload, user, loading, onRemove, handleSubmit, isLoading, file, error, userid, message }) => {

        return (
            <Form layout="vertical" onSubmit={handleSubmit(form, file, 1, userid)}>
                <Col md={12} className='p-0'>
                    <h3 className='mt-0 mb-5 subtitleRegistro text-white text-uppercase' style={{fontFamily: 'Axiforma Black'}}>Complemente seus dados</h3>    
                </Col>
                <Col md={12}>
                    {error !== null && <Alert type="error" message={error} className="mb-5" />}
                </Col>
                <Col md={12} className='p-0 pr-2 mb-3'>
                    <Form.Item label="Nome Completo">
                        {form.getFieldDecorator('nome', {
                            rules: [
                                infoRequired,
                                validateName()
                            ], initialValue: user.nome
                            })(
                            <Input placeholder="Nome Completo" onChange={maskNomeOnChange} onKeyPress={maskNomeOnChange} />
                        )}
                    </Form.Item>
                </Col>
                <Col md={6} className='p-0 pr-2 mb-3'>
                    <Form.Item label={<NomeCelular />}>
                        {form.getFieldDecorator('telefone', {
                            rules: [
                                infoRequired,
                                validateTelefone()
                            ], initialValue: user.telefone
                            })(
                            <Input placeholder="Número de celular" onChange={maskTelefone} onKeyPress={maskTelefone} />
                        )}
                    </Form.Item>
                </Col>
                <Col md={6} className='p-0 pl-2 mb-3'>
                    <Form.Item label="E-mail">
                        {form.getFieldDecorator('email', {
                            rules: [
                                infoRequired,
                                validateEmail()
                            ], initialValue: user.email
                        })(
                            <Input type="email" placeholder="E-mail" readOnly />
                        )}
                    </Form.Item>
                </Col>
                <Col md={6} className='p-0 pr-2 mb-3'>
                    <Form.Item label="Data de Nascimento">
                        {form.getFieldDecorator('nascimento', {
                            rules: [ infoRequired ]
                        })(
                            <DatePicker
                                placeholder="Data de Nascimento"
                                disabledDate={startDate => startDate.isSameOrAfter(moment())}
                                format="YYYY-MM-DD"
                                style={{ width: '100%' }}
                                className="mt-2"
                            />
                        )}
                    </Form.Item>
                </Col>
                <Col md={6} className='p-0 pl-2 mb-3'>
                    <Form.Item label="CPF">
                        {form.getFieldDecorator('cpf', {
                            rules: [
                                infoRequired,
                                validateCpf()
                            ]
                        })(
                            <Input placeholder="CPF" onChange={maskCpf} onKeyPress={maskCpf} className="mt-2" />
                        )}
                    </Form.Item>
                </Col>
                <Col md={6} className='p-0 pr-2 mb-3'>
                    <Form.Item label="RG">
                        {form.getFieldDecorator('rg', {
                            rules: [ infoRequired ]
                        })(
                            <Input placeholder="RG" onChange={alphaOnlyOnChange} onKeyPress={alphaOnlyOnChange} />
                        )}
                    </Form.Item>
                </Col>
                <Col md={6} className='p-0 pl-2 mb-3'>
                    <Form.Item label="Nome da Mãe ou Pai">
                        {form.getFieldDecorator('nomeMae', {
                            rules: [
                                infoRequired,
                            ]
                        })(
                            <Input placeholder="Nome da Mãe ou Pai" />
                        )}
                    </Form.Item>
                </Col>
                {/* <Col md={12} className="p-0">
                    <Dragger className='uploadCadastro' beforeUpload={beforeUpload} onRemove={onRemove}>
                        <UploadIcon />
                        <p className="text-white mt-3">
                           {file === null ? 'Faça o upload do seu\rdocumento de identidade (opcional)' : 'Arquivo carregado'}
                        </p>
                    </Dragger>
                    {message !== null && <span className="text-danger mb-3">{message}</span>}
                </Col> */}
                <Col md={12} className="mt-5">
                    <Form.Item>
                        <button className="anchorBtn w-100 buttonRegistro" type='submit'>
                            {isLoading ? <Icon type="loading" /> : "Póximo Passo"}
                        </button>
                    </Form.Item>
                </Col>
            </Form>
        )
    }
)

class Form1 extends PureComponent {

// export default class Form1 extends Component {
    constructor(props) {
        super(props)
        this.state = {
            file: null,
            message: null
        }
    }

    beforeUpload = file => {
        const specialChars = /^[a-zA-Z0-9_-\d ]+$/
        const fileWithoutExtension = file.name.split('.').slice(0, -1).join()
        const acceptedFormats = ['jpeg', 'jpg', 'pdf', 'png']
        const fileSize = file.size
        if (specialChars.test(fileWithoutExtension) === false) {
            this.setState({ message: 'O nome do arquivo não pode conter caracteres especiais e acentos.' })
        } else if (acceptedFormats.includes(file.name.split('.')[1]) === false) {
            this.setState({ message: 'Por favor, envie arquivos nos formatos jpg, jpeg, pdf ou png.' })
        } else if (fileSize > 5242880) { // 5MB in bytes
            this.setState({ message: 'Por favor, envie arquivos de até 5MB.' })               
        } else {
                this.setState({file})
            }
        return false
    }

    onRemove = () => {
        this.setState({ file: null })
    }
    
    render() {
        const { user, loading, handleSubmit, isLoading, error, userid } = this.props
        return(
            <Row>
                <FormDados user={user} loading={loading} beforeUpload={this.beforeUpload} onRemove={this.onRemove} handleSubmit={handleSubmit} isLoading={isLoading} file={this.state.file} error={error} userid={userid} message={this.state.message} />
            </Row>
            )
    }
}
export default Form1
